import { getAuth } from "firebase/auth";
import { collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const UpdateAgentStatusToInActive = async (agentId) => {
  try {
    let agentDoc = await doc(db, "clients", getLocalStorageItem("bid"));
    agentDoc = await collection(agentDoc, "agents");
    agentDoc = await doc(agentDoc, agentId);
    const data = {
      status: "inactive",
      uid: getAuth().currentUser.uid,
      ...HelperForMetaData({}),
    };
    delete data.createdAt;
    delete data.createdBy;
    return await updateDoc(agentDoc, data)
      .then((res) => true)
      .catch((err) => false);
  } catch (error) {
    console.log(error);
  }
};

export default UpdateAgentStatusToInActive;
